import React, { Suspense } from 'react';
import classNames from 'clsx';

import retryImport from 'app/shared/helpers/retryImport';
import lazyWithReload from 'app/shared/helpers/lazyWithReload';
import { CurrencyFormattedOwnProps } from './CurrencyFormatted.interfaces';
import { useStyles } from './CurrencyFormatted.styles';
import { LabelEnum } from 'app/shared/enums';

const Currency = lazyWithReload(() =>
  retryImport(() => import('react-currency-format'))
);

export default function CurrencyFormatted({
  className,
  quantity,
  hideTrailingZeros,
  renderValue,
  suffix = ` ${LabelEnum.ZL}`,
}: CurrencyFormattedOwnProps) {
  const classes = useStyles();

  const renderText = (value: string) => {
    return (
      <span className={classNames(classes.root, className)}>
        {renderValue ? renderValue(value) : value}
      </span>
    );
  };

  if (typeof quantity !== 'number') {
    return null;
  }

  return (
    <Suspense fallback={<div />}>
      <Currency
        value={quantity}
        suffix={suffix}
        displayType={'text'}
        renderText={renderText}
        thousandSeparator={' '}
        decimalSeparator={','}
        decimalScale={hideTrailingZeros ? 0 : 2}
        fixedDecimalScale
      />
    </Suspense>
  );
}
